// extracted by mini-css-extract-plugin
export default {"layout":"App_layout__hxTYw","content":"App_content__y+0Nc"};